export default function() {
    this.loadAgencies()
}
